import { render, staticRenderFns } from "./beneficiary-aud-bt-state.vue?vue&type=template&id=22fe6ae3&"
import script from "./beneficiary-aud-bt-state.vue?vue&type=script&lang=js&"
export * from "./beneficiary-aud-bt-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports